// Thin wrapper around the Recurly.js v4 client.
//
// Recurly.js is already loaded globally as a CDN <script> in public/index.html
// (https://js.recurly.com/v4/recurly.js), the same way it's used today in
// src/views/SmartRamp/ProductRegistration/ProductPayment.vue. This module
// just centralizes configuration + tokenization for the new Message IQ
// signup flow so it isn't duplicated ad hoc in components.
//
// NOTE on env var: the existing registration flow already configures Recurly
// using VUE_APP_RECURLY_ID (see .env / .env.development.local and
// ProductPayment.vue). We reuse that same public key var here rather than
// introducing a second, differently-named env var (e.g. VUE_APP_RECURLY_PUBLIC_KEY)
// for the same value. If a dedicated key is later wanted for this flow,
// set VUE_APP_RECURLY_PUBLIC_KEY and swap the line below.

let configured = false;

function getRecurly() {
    if (typeof window === "undefined" || !window.recurly) {
        throw new Error("Recurly.js failed to load. Check the script tag in public/index.html.");
    }
    return window.recurly;
}

export function configure() {
    if (configured) return;
    const publicKey = process.env.VUE_APP_RECURLY_PUBLIC_KEY || process.env.VUE_APP_RECURLY_ID;
    getRecurly().configure({ publicKey });
    configured = true;
}

/**
 * Tokenizes a form (or set of Recurly hosted fields) via Recurly.js.
 * `formElement` should be a <form> ref containing the `data-recurly` fields.
 * Resolves with the Recurly token id, or rejects with the Recurly error.
 */
export function tokenize(formElement) {
    configure();
    return new Promise((resolve, reject) => {
        getRecurly().token(formElement, (err, token) => {
            if (err) {
                reject(err);
            } else {
                resolve(token.id);
            }
        });
    });
}

export default {
    configure,
    tokenize
};
